import React from 'react';
import { Route, Redirect } from 'react-router';

import { authorities } from 'app/dealer/constants';
import { GuardedRoute } from 'app/dealer/shared/components/GuardedRoute/GuardedRoute';
import { fetchAuthorities } from 'app/dealer/shared/modules/authorities/actions';

import { getNetwork } from '../account/Network/actions';

const { MANAGE_MY_NETWORK, READ_MY_NETWORK } = authorities;
const requiredAuthorities = [MANAGE_MY_NETWORK, READ_MY_NETWORK];

const refreshNetworkAndAuthorities = ({ dispatch }) => async (
  nextState,
  replace,
  next
) => {
  try {
    await dispatch(getNetwork());
    await dispatch(fetchAuthorities());
    return next();
  } catch (error) {
    return next();
  }
};

export const getLeadsRoutes = (store) => {
  const { getState } = store;

  return (
    <Route name="leads" onEnter={refreshNetworkAndAuthorities(store)}>
      <Redirect from="/dealer/leads" to="/dealer/leads/open-leads" />
      <GuardedRoute
        getComponent={() =>
          import('./Leads/Leads/ConnectedLeads').then((c) => c.ConnectedLeads)
        }
        getState={getState}
        path="/dealer/leads"
        requiredAuthorities={requiredAuthorities}
        redirectTo="/dealer/login"
      >
        <Route
          path="/dealer/leads/open-leads"
          getComponent={() =>
            import('./OpenLeads/OpenLeads/ConnectedOpenLeads').then(
              (c) => c.ConnectedOpenLeads
            )
          }
        />
        <Route
          path="/dealer/leads/closed-leads"
          getComponent={() =>
            import('./ClosedLeads/ClosedLeads/ConnectedClosedLeads').then(
              (c) => c.ConnectedClosedLeads
            )
          }
        />
        <Route
          path="/dealer/open-leads/:id"
          getComponent={() =>
            import('./Lead/Lead/ConnectedLead').then((c) => c.ConnectedLead)
          }
        />
        <Route
          path="/dealer/closed-leads/:id"
          getComponent={() =>
            import('./Lead/Lead/ConnectedLead').then((c) => c.ConnectedLead)
          }
        />
      </GuardedRoute>
    </Route>
  );
};
